import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import * as oktaConfig from './app/config/okta.config';

if (environment.production) {
  enableProdMode();
}

/**
 * Bootstrap the application
 */
function runBootstrap() {
  console.log("runBootstrap");
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

/**
 * Is this application running locally or on Azure?
 */
const isAzure = environment.UseMsal || environment.UseOkta;
const _window: any = window;

if (!isAzure || _window.apiKeyInfo) {
  // if WinAuth or ApiKey run bootstrap immediately
  runBootstrap();
} else {
  /**
   * Is the application running in an iframe?
   */
  const isIframe = window !== window.parent && !window.opener;
  if (isIframe) {
    console.log("Running in iframe: skip bootstrap...");
  } else if (environment.UseMsal) {
    console.log("Running using MSAL");
    runBootstrap();
  } else if (environment.UseOkta) {
    const oktaConfigInstance = oktaConfig.OktaConfigFactory();
    const oktaAuth = oktaConfigInstance.oktaAuth;
    if (oktaAuth.token.isLoginRedirect()) {
      //restore original url
      const requestedUrl = sessionStorage.getItem('app:requestedUrl');
      sessionStorage.removeItem('app:requestedUrl');
      // Parse code or tokens from the URL, store tokens in the TokenManager, and redirect back to the originalUri
      oktaAuth.handleLoginRedirect(null, requestedUrl).then(() => {
        runBootstrap();
      });
    } else {
      //save requested url in case app redirects to login, so we can set it back
      const requestedUrl = window.location.href;
      sessionStorage.setItem('app:requestedUrl', requestedUrl);

      //check if we have valid idToken
      //https://github.com/okta/okta-auth-js#tokenmanagergetkey
      oktaAuth.tokenManager.get('idToken')
        .then((token) => {
          if (token && !oktaAuth.tokenManager.hasExpired(token)) {
            runBootstrap();
          } else {
            // Token has been removed due to expiration or error while renewing
            oktaAuth.token.getWithRedirect({ responseType: 'token' });
          }
        })
        .catch((err) => {
          // handle OAuthError or AuthSdkError (AuthSdkError will be thrown if app is in OAuthCallback state)
          console.error(err);
          oktaAuth.token.getWithRedirect({ responseType: 'token' });
        });
    }
  }
}
